import styled from 'styled-components';
import ImageOnda from '../../../../assets/images/onda.svg';
import ImageOndaSmall from '../../../../assets/images/onda-small.svg';
import { Typography } from '@material-ui/core';

export const TrainingOptionsContainer = styled.section`
	position: relative;
	overflow: hidden;
	color: #f7f7f7;
	background-color: #111111;
	background-image: linear-gradient(rgba(0, 0, 0, 0.84), rgba(20, 20, 20, 0.94)),
		url(${ImageOndaSmall});
	background-size: cover;
	background-position: center;

	${props => props.theme.breakpoints.up('xs')} {
		padding: 16% 7% 18%;
	}

	${props => props.theme.breakpoints.up('sm')} {
		padding: 8% 7% 9%;
		background-image: linear-gradient(rgba(0, 0, 0, 0.84), rgba(20, 20, 20, 0.94)),
			url(${ImageOnda});
	}

	${props => props.theme.breakpoints.up('md')} {
		padding-left: 5%;
		padding-right: 5%;
	}
`;

export const TrainingTitle = styled(Typography)`
	&& {
		color: #ffffff;
		text-align: center;
		margin-bottom: 7%;
		font-weight: 300;

		${props => props.theme.breakpoints.up('xs')} {
			font-size: 36px;
			line-height: 1.12;
		}

		${props => props.theme.breakpoints.up('sm')} {
			font-size: 54px;
			margin-bottom: 5%;
		}

		${props => props.theme.breakpoints.up('md')} {
			font-size: 68px;
		}
	}
`;

export const OptionsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 28px;
	max-width: 1420px;
	margin: 0 auto;

	${props => props.theme.breakpoints.up('md')} {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 4.5%;
	}
`;

export const OptionCard = styled.article`
	display: flex;
	flex-direction: column;
	border: 1px solid rgba(255, 255, 255, 0.72);
	border-radius: 42px;
	padding: 34px 30px 28px;
	min-height: 610px;
	background: rgba(9, 9, 9, 0.36);

	${props => props.theme.breakpoints.up('sm')} {
		padding: 34px 40px 30px;
	}
`;

export const OptionHeading = styled.div`
	display: flex;
	align-items: center;
	gap: 18px;

	h3 {
		color: #f7f7f7;
		font-size: 30px;
		font-weight: 300;
	}

	${props => props.theme.breakpoints.up('sm')} {
		h3 {
			font-size: 36px;
		}
	}

	@media (min-width: 1200px) {
		h3 {
			white-space: nowrap;
		}
	}

	span {
		flex-basis: 70px;
		width: 70px;
		height: 70px;
	}

	span svg {
		font-size: 37px;
	}
`;

export const FeatureIcon = styled.span`
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 45px;
	width: 45px;
	height: 45px;
	border: 1px solid transparent;
	border-radius: 50%;
	color: #ffffff;
	background: radial-gradient(
				circle at 76% 78%,
				#197eaf 0%,
				#0b3e67 40%,
				#061827 74%
			)
			padding-box,
		linear-gradient(135deg, #061827 0%, #061827 30%, #0a3355 63%, #079ed5 100%)
			border-box;
	box-shadow: inset -5px -5px 11px rgba(13, 167, 222, 0.42),
		3px 4px 8px -3px rgba(3, 146, 206, 0.9);

	svg {
		position: relative;
		z-index: 1;
		font-size: 24px;
	}
`;

export const OptionDivider = styled.hr`
	width: 100%;
	border: 0;
	border-top: 1px solid rgba(255, 255, 255, 0.62);
	margin: 27px 0 24px;
`;

export const ModuleList = styled.div`
	font-size: 15px;
	padding-left: 12px;

	ol {
		margin: 10px 0 0 48px;
		padding: 0;
		list-style: none;
	}

	li {
		display: flex;
		align-items: baseline;
		gap: 7px;
		color: rgba(255, 255, 255, 0.83);
		line-height: 1.55;
	}

	li span {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 19px;
		width: 19px;
		height: 19px;
		border: 1px solid transparent;
		border-radius: 50%;
		font-size: 13px;
		font-weight: 700;
		color: #ffffff;
		background: radial-gradient(
					circle at 76% 78%,
					#197eaf 0%,
					#0b3e67 40%,
					#061827 74%
				)
				padding-box,
			linear-gradient(135deg, #061827 0%, #061827 30%, #0a3355 63%, #079ed5 100%)
				border-box;
		box-shadow: inset -2px -2px 4px rgba(13, 167, 222, 0.42),
			2px 2px 4px -2px rgba(3, 146, 206, 0.9);
	}
`;

export const ModuleCount = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	p {
		color: #f0f0f0;
	}

	span {
		flex-basis: 45px;
		width: 45px;
		height: 45px;
	}

	span svg {
		font-size: 24px;
	}
`;

export const FeatureList = styled.div`
	display: grid;
	gap: 18px;
	margin-top: 25px;
	margin-bottom: 24px;
	padding-left: 12px;
`;

export const Feature = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
	color: rgba(255, 255, 255, 0.86);
	font-size: 17px;
	line-height: 1.25;

	&.included-online {
		margin-top: -8px;
		margin-left: 12px;
	}
`;

export const PlusDivider = styled.div`
	display: flex;
	align-items: center;
	gap: 13px;
	margin: 2px 0 0;

	span {
		flex: 1;
		border-top: 1px solid rgba(255, 255, 255, 0.6);
	}

	svg {
		font-size: 36px;
		color: #ffffff;
	}
`;

export const HybridFeatureList = styled(FeatureList)`
	margin-top: 12px;
`;

export const Callout = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
	margin-top: auto;
	min-height: 90px;
	box-sizing: border-box;
	padding: 18px 20px;
	border-radius: 20px;
	color: #4c4c4c;
	background: #f3f3f3;
	font-size: 15px;
	font-weight: 700;
	line-height: 1.22;

	svg {
		flex: 0 0 auto;
		font-size: 38px;
		color: #0392ce;
	}

	&.online-callout {
		margin-top: auto;
	}
`;

export const InfoButton = styled.a`
	align-self: center;
	min-width: 172px;
	margin-top: 16px;
	padding: 10px 20px;
	border: 1px solid #0392ce;
	border-radius: 4px;
	color: #ffffff;
	background: rgba(3, 146, 206, 0.16);
	font: inherit;
	font-size: 15px;
	font-weight: 700;
	text-align: center;
	text-decoration: none;
	cursor: pointer;
	transition: background-color 160ms ease, border-color 160ms ease;

	&:hover,
	&:focus {
		border-color: #20b9f6;
		background: rgba(3, 146, 206, 0.34);
	}
`;
